import { queryOptions } from '@tanstack/react-query'
import apiClient from '../lib/apiClient'
import { AUTH_QUERY_KEYS } from './queryKeys'
import { endpoints } from './endPoint'

// --- API Functions ---

export const getUserProfile = async () => {
  const { data } = await apiClient.get('/auth/me')
  return data
}

interface LoginCredentials {
  email: string
  password: string
  loginFromAdmin: boolean
}

export const loginUser = async (credentials: LoginCredentials) => {
  const response = await apiClient.post(endpoints.auth.login, credentials)
  return response.data.data
}

export const logoutUser = async () => {
  try {
    await apiClient.post(endpoints.auth.logout)
  } catch (error) {
    console.error('Logout API call failed:', error)
    throw error
  }
}

export const requestPasswordReset = async (payload: { email: string }) => {
  const response = await apiClient.post(
    endpoints.auth.forgotPassword.requestOtp,
    payload
  )
  return response.data
}

export const verifyPasswordResetOtp = async (payload: { token: string }) => {
  const response = await apiClient.post(
    endpoints.auth.forgotPassword.verifyOtp,
    payload
  )
  return response.data
}

export const setNewPassword = async (payload: {
  token: string
  password: string
}) => {
  const response = await apiClient.post(
    endpoints.auth.forgotPassword.setNewPassword,
    payload
  )
  return response.data
}

// --- Query Options ---

export const authQueryOptions = {
  userProfile: () =>
    queryOptions({
      queryKey: AUTH_QUERY_KEYS.userProfile,
      queryFn: getUserProfile,
    }),
}
